import { useEffect, useState } from 'react';
import { getDesktopOrMobile } from './deviceDetails';

export const useDeviceOrientation = () => {
    const [isDesktop, setIsDesktop] = useState(getDesktopOrMobile());
    const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(getDesktopOrMobile());
            setIsLandscape(window.innerWidth > window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return { isDesktop, isLandscape };
};
